export default [
  {
    label: '阿里云图标',
    list: [
      'icon-quanxianguanli',
      'icon-yonghuguanli',
      'icon-jiaoseguanli',
      'icon-web-icon-',
      'icon-xitongguanli',
      'icon-rizhiguanli',
      'icon-navicon-zdgl',
      'icon-weibiaoti46',
      'icon-miyue',
      'icon-shouji',
      'icon-miyue',
      'icon-denglvlingpai',
      'icon-luyou',
      'icon-msnui-supervise',
      'icon-server',
      'icon-wendang',
      'icon-gtsquanjushiwufuwuGTS',
      'icon-caidanguanli',
      'icon-guanwang',
      'icon-guanwangfangwen',
      'icon-guiji',
      'icon-fensiguanli',
      'icon-gongzhonghao',
      'icon-anniu_weixincaidanlianjie',
      'icon-weixincaidan',
      'icon-xiaoxiguanli',
      'icon-zhexiantu',
      'icon-canshu',
      'icon-erji-zuhushouye',
      'icon-pay6zhifu',
      'icon-zhifuqudaoguanli',
      'icon-dingdan',
      'icon-tuikuan',
      'icon-webicon14',
      'icon-shouyintai',
      'icon-wenjianguanli',
      'icon-mysql',
      'icon-shejiyukaifa-',
      'icon-record',
      'icon-emaxcitygerenxinxitubiaoji03',
      'icon-risk-o',
      'icon-quality-business',
      'icon-resource_capacity',
      'icon-pinzhibaozhengQuality',
      'icon-otherrisk',
      'icon-order1',
      'icon-jinhangzhong',
      'icon-yichang',
      'icon-shenpi',
      'icon-liebiao',
      'icon-biaodanbiaoqian',
      'icon-huodong',
      'icon-huodongshuju',
      'icon-jubao1',
      'icon-jubao2',
      'icon-dahui',
      'icon-chuliyichang',
      'icon-renyuanyichang-xian',
      'icon-beiyong',
      'icon-beiyong1',
      'icon-huodong1',
      'icon-huodongzhuanqu',
      'icon-huodongguanli',
      'icon-huodongtuijian',
      'icon-huodong2',
      'icon-shixi'
    ]
  }
]
